var _circle, _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFilesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 45.5,
    cy: 45,
    r: 45,
    fill: "#5E639B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6226,
    y: 21.25,
    width: 28.625,
    height: 40.013,
    rx: 1,
    fill: "#F8F8FB",
    stroke: "#BEBECE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0151 31.0601L53.0151 31.0601L53.0197 31.0642L57.1043 34.7069C57.317 34.8966 57.4387 35.1681 57.4387 35.4532V67C57.4387 67.5523 56.991 68.0001 56.4387 68.0001H28.7495C28.1972 68.0001 27.7495 67.5523 27.7495 67.0001V27.5488C27.7495 26.9965 28.1972 26.5488 28.7495 26.5488H47.6344C47.882 26.5488 48.1208 26.6407 48.3046 26.8066L53.0151 31.0601Z",
    fill: "#F8F8FB",
    stroke: "#BEBECE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4028 27.0005L48.4028 32.5569C48.4028 33.6615 49.2983 34.5569 50.4028 34.5569H56.5",
    stroke: "#BEBECE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2396 53.6862L48.3272 53.5765C49.6401 52.0407 50.3622 50.11 50.3622 48.0915C50.3622 43.4622 46.5985 39.6885 41.9814 39.6885C37.3644 39.6885 33.6226 43.4622 33.6226 48.0915C33.6226 52.7208 37.3862 56.4945 42.0033 56.4945C43.8851 56.4945 45.6795 55.8802 47.1674 54.7174L47.2549 54.6516L52.7692 59.1273L53.6226 58.0742L48.2396 53.6862ZM42.0033 55.1342C38.1302 55.1342 34.9792 51.9749 34.9792 48.0915C34.9792 44.2081 38.1302 41.0488 42.0033 41.0488C45.8764 41.0488 49.0274 44.2081 49.0274 48.0915C49.0274 51.9749 45.8764 55.1342 42.0033 55.1342Z",
    fill: "#BEBECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.65 45.2974L39.1392 44.8066L45.4986 51.1871L45.0094 51.6779L38.65 45.2974Z",
    fill: "#BEBECE",
    stroke: "#BEBECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0074 44.8066L45.4966 45.2974L39.1371 51.6778L38.6479 51.187L45.0074 44.8066Z",
    fill: "#BEBECE",
    stroke: "#BEBECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFilesSmall);
export default __webpack_public_path__ + "static/media/NoFilesSmall.ebb56a012537e564dead351b25fb9a14.svg";
export { ForwardRef as ReactComponent };